<template>
  <div class="nav-menu">
    <ul>
      <li
        v-for="(i, index) in menuList"
        :key="index"
        :class="{'active': activeIndex === index}"
      >
        <el-tooltip
          :content="i.showText"
          placement="top"
          effect="light"
          popper-class="nav-menu-poppver"
        >
          <a
            href="javascript:void(0)"
            @click="jumpToLibary(i, index)"
          ><span class="menu-name">{{ i.name }}</span></a>
        </el-tooltip>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    menuList: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      activeIndex: 0
    }
  },
  watch: {
    '$route' (val) {
      this.setDefaultIndex(val.path)
    }
  },
  mounted () {
    this.setDefaultIndex(this.$route.path)
  },
  methods: {
    setDefaultIndex (path) {
      this.menuList.forEach((item, index) => {
        if (path.indexOf(item.url) !== -1) {
          this.activeIndex = index
        }
      })
    },
    // 跳转到相应的库
    jumpToLibary (libary, index) {
      if (libary.isLogin) {
        this.$router.push(libary.url)
      } else {
        this.$emit('no-privilidge')
      }
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/modules/common/header/menuList.vue